import { LinksConstrains } from "@/enums/links.enum";
import { RouteConfig } from "vue-router";
import AccountSettingsRoutes from "./accounts/routes";

const routes: Array<RouteConfig> = [
  {
    path: LinksConstrains.SETTINGS,
    name: "menu.settings",
    component: () => import("./index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings" },
  },
  {
    path: LinksConstrains.SETTINGS_BUSINESS_LOCATION,
    name: "settings_location_link",
    component: () => import("./business/locations/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Location", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_BUSINESS_LOCATION_DIGITAL_MENU,
    name: "settings_location_link",
    component: () => import("@posrocket/digital-menu/src/views/menu/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Location Digital Menu", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_BUSINESS_DEVICES,
    name: "settings_devices_link",
    component: () => import("./business/devices/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings devices", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_BUSINESS_DRIVER,
    name: "settings_drivers_link",
    component: () => import("./business/drivers/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Location", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_BUSINESS_ORDER_SOURCE,
    name: "settings_order_source_link",
    component: () => import("./business/order-source/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Order Source", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_BUSINESS_SALES_OPTION,
    name: "settings_sales_options_link",
    component: () => import("./business/sales-options/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Sales Options", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_BUSINESS_UNITS,
    name: "settings_units_link",
    component: () => import("./business/units/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Units", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_BUSINESS_DETAILS,
    name: "settings_business_details_link",
    component: () => import("./business/details/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Business Details", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_CASH_AND_PAYMENT_EXTRA_CHARGES,
    name: "menu.extra_charge",
    component: () => import("./cash-and-payment/extra-charges/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Cash & Payment", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_CASH_AND_PAYMENT_TAXES,
    name: "menu.taxes",
    component: () => import("./cash-and-payment/taxes/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Cash & Payment", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_CASH_AND_PAYMENT_DISCOUNTS,
    name: "menu.discounts",
    component: () => import("./cash-and-payment/discounts/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Discount", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_CASH_AND_PAYMENT_CURRENCIES,
    name: "menu.currencies",
    component: () => import("./cash-and-payment/currencies/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Currency Management", parent: "settings" },
  },
  {
    path: LinksConstrains.SETTINGS_CASH_AND_PAYMENT_PAY_IN_OUT,
    name: "settings-payment-categories",
    component: () => import("./cash-and-payment/pay-in-out/index.vue"),
    meta: { isAuth: true, title: "POSRocket | Settings Pay In/Out", parent: "settings" },
  },
  ...AccountSettingsRoutes,
];

export default routes;
